import Breadcrumb from '@/components/Breadcrumb';
// TODO: Dupe useBreadcrumbs to ../hooks/
import { useBreadcrumbs } from '@/pages/CompanyReport/components/Overview/components/DeprecatedHeader/hooks/useBreadcrumbs';
import { Bones } from './Bones';
import type { ReactNode } from 'react';

export const BreadcrumbNav = ({ children }: { children: ReactNode }) => {
  const { breadcrumbs, status } = useBreadcrumbs();

  return (
    <div className="grid select-none grid-cols-[1fr_auto] items-baseline justify-between gap-x-x2 gap-y-x0_5 text-softer">
      {/* TODO: Breadcrumb: Expose custom li slot to style the crumbs directly 
      instead of using the arbitrary variants (`[&_*]:`) below */}
      <div className="truncate [&_*]:gap-x0_5 [&_*]:text-tiny [&_*]:no-underline [&_*]:min-[375px]:text-xs [&_a:focus]:text-soft">
        {status === 'success' ? (
          <Breadcrumb list={breadcrumbs} />
        ) : (
          <Bones className="max-w-[20ch]" />
        )}
      </div>
      <div className="whitespace-nowrap text-right text-tiny min-[375px]:text-xs">
        {children ?? (
          // Zero whitespace character (avoid layout shift)
          <>&#8203;</>
        )}
      </div>
    </div>
  );
};
